export const createDocumentRoot = () => {
	// Add dynamic top level styles to the document body
	const ui =
		new URLSearchParams(window.location.search).get("ui") || "fullscreen";
	const styles = {
		inline: `
                html, body, #root {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                    overflow-y: hidden;
                    background-color: transparent;
                }
            `,
		fullscreen: `
                html {
                    overflow-y: scroll;
                }
                html, body, #root {
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    box-sizing: border-box;
                    background-color: #fff;
                }
            `,
	};
	// a11y fallback: browsers without :focus-visible (Safari < 15.4, Chrome < 86,
	// Firefox < 85) don't apply the app's `&:focus-visible` focus rings, and many
	// controls set `outline: none`, leaving keyboard users with no focus
	// indicator. Restore a visible outline on focus there (class set in
	// src/browserSupport.ts). Only affects those older browsers.
	const focusVisibleFallback = `
                html.no-focus-visible a:focus,
                html.no-focus-visible button:focus,
                html.no-focus-visible input:focus,
                html.no-focus-visible select:focus,
                html.no-focus-visible textarea:focus,
                html.no-focus-visible [tabindex]:focus {
                    outline: 2px solid #00f;
                    outline-offset: 2px;
                }
            `;
	const styleText =
		(styles[ui as keyof typeof styles] || styles.fullscreen) +
		focusVisibleFallback;
	const style = document.createElement("style");
	style.type = "text/css";
	if ((style as any).styleSheet) {
		(style as any).styleSheet.cssText = styleText;
	} else {
		style.appendChild(document.createTextNode(styleText));
	}
	document.body.appendChild(style);
	// Create root element
	const root = document.createElement("div");
	root.setAttribute("id", "root");
	document.body.appendChild(root);
	return root;
};
